import s from './connect-student-modal.module.scss'
import { Modal } from '@shared/ui/modal/modal';
import { Button } from '@shared/ui/button/button';
import { Input } from '@shared/ui/input/input';
import { FormProvider, useForm } from 'react-hook-form';
import { useConnectStudent } from '../../api/useConnectStudent';
import { useConnectStudentModal } from '../../model/use-connect-student-modal';

export const ConnectStudentModal = () => {
	const { isOpen, close } = useConnectStudentModal()
	
	const { mutate } = useConnectStudent()

	const methods = useForm({
		mode: 'onTouched'
	})

	const { formState } = methods

  const handleSubmit = methods.handleSubmit(data => {
		const loginPayload = {
			email: data.email,
		}
		
		mutate(loginPayload)
		close()
  })

	const email = methods?.watch('email')
	const notValid = (!formState.isValid && formState.isDirty) || !email

  return (
		<Modal {...{isOpen, close}} title="Добавить ученика">
			<div className={s.card}>
				<FormProvider {...methods}>
					<form onSubmit={handleSubmit} className={s.form}>
						<span className={s.caption}>
							Чтобы назначать ученику занятия, добавьте его в список своих учеников, указав адрес его эл. почты
						</span>
							<Input
								placeholder='Email' 
								name='email' 
								className={s.input}
								validation={{
									required: {
										value: true,
										message: 'Заполните поле',
									},
									validate: {
										maxLength: (v) =>
											v?.length <= 50 || "Почта должна содержать не более 50 символов.",
										matchPattern: (v) =>
											/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
											"Адрес электронной почты недействителен.",
									},
								}}/>
							<Button label='Добавить' className={s.btn} disabled={notValid}/>
						</form>
				</FormProvider>
			</div>
		</Modal>
  );
};